// Firebase client initialization with safe checks
import { initializeApp, getApps } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';

export const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyAo_YlQ9jFkvw0OXbHLfk6cR_wZdmZgNgU",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "nirmitee-associates.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "nirmitee-associates",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "nirmitee-associates.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "393910394687",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:393910394687:web:deb98b050ebb215fab3d8a",
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "G-2H8F2XP5S6"
};

export const isFirebaseConfigured = () => {
  return Boolean(firebaseConfig.projectId);
};

let app = null;
let db = null;
let storage = null;
let auth = null;
let analytics = null;

if (isFirebaseConfigured()) {
  app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
  db = getFirestore(app);
  storage = getStorage(app);
  auth = getAuth(app);

  // Initialize analytics only in browser environment
  if (typeof window !== 'undefined') {
    analytics = getAnalytics(app);
  }
}

export { app, db, storage, auth, analytics };


